import type { RetentionSettingsPayload } from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsFetched';

export type RetentionSettingsUpdatedAction = {
	type: 'RETENTION_SETTINGS_UPDATED';
	payload: RetentionSettingsPayload;
};

export default (payload: RetentionSettingsPayload): RetentionSettingsUpdatedAction => ({
	type: 'RETENTION_SETTINGS_UPDATED',
	payload,
});
